import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Brands/muller-martini.png")